const encodePm = (pm: string) => encodeURIComponent(pm).replace(/\./g, '%2E')

export const NEW_AGENT_CHAT_ROUTE_ID = 'new'

export const buildAgentConversationPath = (
  pm: string,
  conversationId: string
) => `/portal/${encodePm(pm)}/agent/chat/${encodeURIComponent(conversationId)}`

export const buildNewAgentChatPath = (pm: string) =>
  buildAgentConversationPath(pm, NEW_AGENT_CHAT_ROUTE_ID)

export const getPersistedAgentConversationId = (
  routeConversationId?: string
) =>
  routeConversationId && routeConversationId !== NEW_AGENT_CHAT_ROUTE_ID
    ? routeConversationId
    : null

// Handoffs from outside the Agent workspace are consumed once on a new chat.
// Keep the text out of the URL, and let the newest handoff replace either mode.
const pendingPromptKey = (pm: string) =>
  `twodots.portalAgent.pendingPrompt.${pm}`
const pendingDraftKey = (pm: string) => `twodots.portalAgent.pendingDraft.${pm}`

export const stashPendingAgentPrompt = (pm: string, text: string) => {
  try {
    sessionStorage.removeItem(pendingDraftKey(pm))
    sessionStorage.setItem(pendingPromptKey(pm), text)
  } catch {
    // Storage unavailable (private mode) — the user lands on an empty new
    // chat and can resubmit there.
  }
}

/** Save editable text without authorizing a send. Navigate only on success. */
export const stashPendingAgentDraft = (pm: string, text: string): boolean => {
  try {
    sessionStorage.removeItem(pendingPromptKey(pm))
    sessionStorage.setItem(pendingDraftKey(pm), text)
    return true
  } catch {
    return false
  }
}

export const consumePendingAgentHandoff = (
  pm?: string | null
): { mode: 'draft' | 'prompt'; text: string } | null => {
  if (!pm) return null
  try {
    const draft = sessionStorage.getItem(pendingDraftKey(pm))
    const prompt = sessionStorage.getItem(pendingPromptKey(pm))
    // Clear both before returning; if stale values coexist, prefer review.
    sessionStorage.removeItem(pendingPromptKey(pm))
    sessionStorage.removeItem(pendingDraftKey(pm))
    if (draft) return { mode: 'draft', text: draft }
    if (prompt) return { mode: 'prompt', text: prompt }
    return null
  } catch {
    return null
  }
}
